<p-dialog
    [(visible)]="displayModal"
    [modal]="true"
    [draggable]="false"
    [resizable]="false"
    [styleClass]="'role-manager-dialog'"
    [style]="{width: 'min(1120px, 94vw)'}"
    (onHide)="onCancel()">
    <ng-template pTemplate="header">
        <div class="dialog-title">
            <span>{{ dialogHeader }}</span>
            <small>Assign one portal role and review exactly what it allows.</small>
        </div>
    </ng-template>

    <div class="role-manager">
        <aside class="role-picker">
            <div class="picker-header">
                <div>
                    <strong>Portal roles</strong>
                    <span>{{ availableRoles.length }} available</span>
                </div>
                <span class="selected-count" *ngIf="selectedRole">{{ selectedPermissionCount }} permissions</span>
            </div>

            <span class="search-box">
                <i class="pi pi-search"></i>
                <input pInputText type="search" [(ngModel)]="searchTerm" placeholder="Search roles or permissions" />
            </span>

            <div class="role-list" *ngIf="!isLoading; else loadingRoles">
                <button
                    type="button"
                    class="role-option"
                    *ngFor="let role of filteredRoles"
                    [class.selected]="isSelected(role)"
                    [class.previewed]="activeRole?.roleId === role.roleId"
                    (click)="selectRole(role)"
                    (mouseenter)="previewRole(role)">
                    <span class="radio-dot" aria-hidden="true"></span>
                    <span class="role-copy">
                        <span style="display: flex; align-items: center; gap: 0.5rem;">
                            <strong>{{ role.roleName }}</strong>
                            <p-tag *ngIf="role.custom" value="Custom" severity="success" styleClass="text-xs"></p-tag>
                        </span>
                        <small>{{ role.description || 'Portal access role' }}</small>
                    </span>
                    <span class="permission-pill">{{ getPermissionCount(role) }}</span>
                </button>

                <div class="empty-state" *ngIf="!filteredRoles.length">
                    No roles match the current search.
                </div>
            </div>

            <ng-template #loadingRoles>
                <div class="empty-state">Loading roles...</div>
            </ng-template>
        </aside>

        <section class="permission-detail" *ngIf="activeRole; else noRoleSelected">
            <div class="detail-header">
                <div>
                    <span class="eyebrow">Role details</span>
                    <h3>{{ activeRole.roleName }}</h3>
                    <p>{{ activeRole.description || 'Portal access role' }}</p>
                </div>
                <button
                    pButton
                    type="button"
                    [label]="isSelected(activeRole) ? 'Selected' : 'Select role'"
                    [icon]="isSelected(activeRole) ? 'pi pi-check' : 'pi pi-circle'"
                    [class.p-button-outlined]="!isSelected(activeRole)"
                    (click)="selectRole(activeRole)">
                </button>
            </div>

            <div class="permission-summary">
                <span>{{ getPermissionCount(activeRole) }}</span>
                <strong>permissions included</strong>
            </div>

            <div class="permission-groups" *ngIf="activePermissionGroups.length; else noPermissions">
                <article class="permission-group" *ngFor="let group of activePermissionGroups">
                    <header>
                        <strong>{{ group.name }}</strong>
                        <span>{{ group.permissions.length }}</span>
                    </header>
                    <div class="permission-grid">
                        <span class="permission-chip" *ngFor="let permission of group.permissions">
                            {{ permission.permissionName }}
                        </span>
                    </div>
                </article>
            </div>

            <ng-template #noPermissions>
                <div class="empty-state">No permissions are attached to this role.</div>
            </ng-template>
        </section>

        <ng-template #noRoleSelected>
            <section class="permission-detail empty-detail">
                <div class="empty-state">Select a role to review its permissions.</div>
            </section>
        </ng-template>
    </div>

    <ng-template pTemplate="footer">
        <div class="dialog-footer">
            <span *ngIf="selectedRole">Saving will replace existing roles with {{ selectedRole.roleName }}.</span>
            <span *ngIf="!selectedRole">Select one role to continue.</span>
            <div>
                <button pButton type="button" label="Cancel" class="p-button-text" (click)="onCancel()"></button>
                <button
                    pButton
                    type="button"
                    label="Save role"
                    icon="pi pi-save"
                    (click)="onSave()"
                    [loading]="isSaving"
                    [disabled]="!selectedRole || isSaving">
                </button>
            </div>
        </div>
    </ng-template>
</p-dialog>
